<template>
  <div>
    <logo-title
      :hotKeyWords="hotKeyWords"
      url="http://daxue.xdf.cn/xinban/"
      logoPos="background-position: 4px -240px"
    ></logo-title>
    <swiper></swiper>
    <keep-alive>
      <cart ></cart>
    </keep-alive>
    <main-floor></main-floor>
  </div>
</template>

<script>
import LogoTitle from '@/common-components/Logotitle'
import Swiper from './components/swiper/Swiper'
import MainFloor from './components/mainfloor/Mainfloor'
import { hotKeyWords } from 'js/univercity/hotkeywords'
import Cart from '@/common-components/Cart'
export default {
  name: 'univercity',
  data () {
    return {
      hotKeyWords
    }
  },
  components: {
    Cart,
    Swiper,
    LogoTitle,
    MainFloor
  }
}
</script>

<style lang="stylus"></style>



// WEBPACK FOOTER //
// src/pages/univercity/Univercity.vue